export const linkClickOpensInNewTab = (evt: React.MouseEvent<HTMLAnchorElement>) => {
  const target = evt.currentTarget.getAttribute('target') || '_self';
  const modifier = [evt.shiftKey, evt.ctrlKey, evt.metaKey].some((k) => k === true);

  return target !== '_self' || modifier;
};
